import { ContactsStartLoading } from '@/store/contacts/actions';
import { GetContactsInterface } from '@/store/contacts/types';
import { useDispatch } from 'react-redux';
import { useContactQueryParams } from './useContactQueryParams';
import { useEntityRuleForFiltration } from './useFiltrationRule';

const createOffset = ({ activePage, perPage }) => ((activePage || 1) - 1) * perPage;

export const useContactReload = () => {
    const dispatch = useDispatch();
    const { entityRule } = useEntityRuleForFiltration();

    const { querySearch, queryOrderBy, queryStatuses, queryPage, queryPerPage } = useContactQueryParams();

    const reloadContactsBasedOnQuery = () => {
        const params: GetContactsInterface = {
            limit: queryPerPage,
            rule: entityRule,
            statuses: queryStatuses,
            search: querySearch,
            orderBy: queryOrderBy,
            offset: createOffset({ activePage: queryPage, perPage: queryPerPage }),
        };

        dispatch(ContactsStartLoading(params));
    };

    return {
        reloadContactsBasedOnQuery,
    };
};
